import React from 'react'
import DashboardLayout from '../../../../layoutcontainers/DashboardLayout'
import { useLocation } from 'react-router-dom';
import { Avatar, Card, Grid, Stack } from '@mui/material';
import MaterialTypography from '../../../../components/MaterialTypography';
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";


const PortfilioDetails = () => {
    const location = useLocation();
    const selectedItem = location.state?.data;

    const truncate = (desc) =>
        desc?.length > 25 ? `${desc.substring(0, 140)}...` : desc;

    return (
        <DashboardLayout>
            <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
                p={1}
                mb={2}
            >
                <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h5" fontWeight="bold" color="dark">
                        {selectedItem.program_name} Portfolio
                    </MaterialTypography>
                    <MaterialTypography variant="caption" color="text">
                        You can view the details here.
                    </MaterialTypography>
                </Stack>
            </Stack>

            <Grid container spacing={2} sx={{ mt: 2, p: 1 }}>
                {selectedItem?.projects.map((item) => (
                    <Grid size={{ xs: 12, sm: 3, md: 3 }} key={item.project_id}>
                        <Card sx={{ p: 1, maxHeight: 240 }}>
                            {/* <Box sx={{ position: "absolute", top: 3, right: 3 }}>
                                <IconButton
                                    onClick={(event) => handleClick(event, item.project_id)}
                                    size="small"
                                >
                                    <MoreVertIcon />
                                </IconButton>
                                <Menu
                                    anchorEl={anchorEl}
                                    open={open && selectedProjectId === item.project_id}
                                    onClose={() => handleClose("")}
                                    anchorOrigin={{
                                        vertical: "bottom",
                                        horizontal: "right",
                                    }}
                                    transformOrigin={{
                                        vertical: "top",
                                        horizontal: "right",
                                    }}
                                >
                                    <MenuItem onClick={() => handleClose("Edit")}>
                                        Edit
                                    </MenuItem>
                                    <MenuItem onClick={() => handleClose("View")}>
                                        View
                                    </MenuItem>
                                    <MenuItem onClick={() => handleClose("Delete")}>
                                        Delete
                                    </MenuItem>
                                </Menu>
                            </Box> */}
                            <Grid container spacing={2}>
                                <Grid size={{ xs: 12, md: 12 }}>
                                    <Stack direction="row" spacing={1} alignItems="center">
                                        <Avatar
                                            alt="Remy Sharp"
                                            src={item.project_logo}
                                            sx={{
                                                width: 40,
                                                height: 40,
                                                "& img": {
                                                    objectFit: "cover",
                                                    width: "100%",
                                                    height: "100%",
                                                },
                                            }}
                                        />
                                        <Stack direction="column" spacing={0}>
                                            <MaterialTypography
                                                variant="h6"
                                                fontWeight="bold"
                                                color="dark"
                                                sx={{ fontSize: "12px" }}
                                            >
                                                {item.project_name}
                                            </MaterialTypography>
                                            <MaterialTypography
                                                variant="caption"
                                                color="text"
                                                sx={{ fontSize: "10px" }}
                                            >
                                                {item.project_code}
                                            </MaterialTypography>
                                        </Stack>
                                    </Stack>
                                </Grid>
                            </Grid>
                            <Grid container spacing={2} mt={1}>
                                <Grid size={{ xs: 12, md: 12 }}>
                                    <MaterialTypography
                                        variant="body2"
                                        color="text"
                                        sx={{ fontSize: "10px" }}
                                    >
                                        {truncate(item.description)}
                                    </MaterialTypography>
                                </Grid>
                            </Grid>
                            <Grid container spacing={2} mt={1}>
                                <Grid size={{ xs: 12, md: 12 }}>
                                    <Stack direction="row" spacing={1}>
                                        <Avatar
                                            alt="Remy Sharp"
                                            src={item.manager_profile}
                                            sx={{
                                                width: 30,
                                                height: 30,
                                                "& img": {
                                                    objectFit: "cover",
                                                    width: "100%",
                                                    height: "100%",
                                                },
                                            }}
                                        />
                                        <Stack direction="column" spacing={0}>
                                            <MaterialTypography
                                                variant="h6"
                                                fontWeight="bold"
                                                color="text"
                                                sx={{ fontSize: "10px" }}
                                            >
                                                {item.manager_name}
                                            </MaterialTypography>
                                            <MaterialTypography
                                                variant="h6"
                                                fontWeight="bold"
                                                color="text"
                                                sx={{ fontSize: "10px" }}
                                            >
                                                Project Manager
                                            </MaterialTypography>
                                        </Stack>
                                    </Stack>
                                </Grid>
                            </Grid>
                            <Grid container spacing={2} mt={1}>
                                <Grid size={{ xs: 6, lg: 6 }}>
                                    <Stack direction="column" spacing={0}>
                                        <MaterialTypography
                                            variant="h6"
                                            fontWeight="bold"
                                            color="text"
                                            sx={{ fontSize: "10px" }}
                                        >
                                            Start Date
                                        </MaterialTypography>
                                        <MaterialTypography
                                            variant="h6"
                                            fontWeight="bold"
                                            color="text"
                                            sx={{ fontSize: "10px" }}
                                        >
                                            {item.start_date}
                                        </MaterialTypography>
                                    </Stack>
                                </Grid>
                                <Grid
                                    size={{ xs: 6, lg: 6 }}
                                    sx={{ display: "flex", flexDirection: "row-reverse" }}
                                >
                                    <Stack direction="column" spacing={0}>
                                        <MaterialTypography
                                            variant="h6"
                                            fontWeight="bold"
                                            color="text"
                                            sx={{ fontSize: "10px" }}
                                        >
                                            Live Date
                                        </MaterialTypography>
                                        <MaterialTypography
                                            variant="h6"
                                            fontWeight="bold"
                                            color="text"
                                            sx={{
                                                fontSize: "10px",
                                                color:
                                                    item.days_left < 30 && item.completion_percent < 50
                                                        ? "red"
                                                        : item.days_left < 5 &&
                                                            item.completion_percent < 80
                                                            ? "orange"
                                                            : "green",
                                                animation: "blinker 3s linear infinite",
                                                "@keyframes blinker": {
                                                    "50%": {
                                                        opacity: 0,
                                                    },
                                                },
                                            }}
                                        >
                                            {item.end_date}
                                        </MaterialTypography>
                                    </Stack>
                                </Grid>
                            </Grid>
                            <Grid container spacing={1} mt={1}>
                                <Grid size={{ xs: 6, lg: 6 }}>
                                    <Stack direction="row" spacing={0} alignItems="center">
                                        <CalendarMonthIcon
                                            sx={{ color: "#00C853", fontSize: 16 }}
                                        />
                                        <MaterialTypography
                                            variant="body2"
                                            color="text"
                                            sx={{ fontSize: "10px" }}
                                        >
                                            {item.days_left} days left
                                        </MaterialTypography>
                                    </Stack>
                                </Grid>
                                <Grid
                                    size={{ xs: 6 }}
                                    sx={{ display: "flex", flexDirection: "row-reverse" }}
                                >
                                    <Stack direction="column" spacing={0}>
                                        <MaterialTypography
                                            variant="body2"
                                            color="text"
                                            sx={{ fontSize: "10px" }}
                                        >
                                            Completed tasks: {item.completion_percent}%
                                        </MaterialTypography>
                                    </Stack>
                                </Grid>
                            </Grid>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </DashboardLayout>
    )
}

export default PortfilioDetails
